import type { CourseKeyEnrollmentRow } from '@/types/course-key';

export function normalizeSearchQuery(query: string): string {
  return query.trim().toLowerCase();
}

export function matchesEnrollmentSearch(
  row: Pick<CourseKeyEnrollmentRow, 'studentName' | 'email' | 'programName'>,
  query: string
): boolean {
  const normalized = normalizeSearchQuery(query);
  if (!normalized) return true;

  const haystack = [row.studentName, row.email, row.programName]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  const tokens = normalized.split(/\s+/).filter(Boolean);
  return tokens.every((token) => haystack.includes(token));
}
